import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { EmailWithTLDValidator } from '@/validators/EmailWithTLDValidator';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { PropertySale, SalesManagementService, UserRole } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { CompanyDialogComponent } from '../company-dialog/company-dialog.component';

import { NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
import { InputComponent } from '../ui-forms/input/input.component';

export class SaleUpdateBuyersDialogData {
  sale: PropertySale;
}

@Component({
    selector: 'app-sale-update-buyers-dialog',
    templateUrl: './sale-update-buyers-dialog.component.html',
    styleUrls: ['./sale-update-buyers-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, FormsModule, ReactiveFormsModule, InputComponent]
})
export class SaleUpdateBuyersDialogComponent implements OnInit, OnDestroy {
  sub = new Subscription();
  dialogTitle: string;
  isLoading = false;

  autoCompletionType: string;

  readonly USER_ROLES_ALLOWED = { users: [UserRole.INDIVIDUAL] };

  get form_buyer() {
    return this.form.get('buyer') as FormControl<string>;
  }
  get form_coBuyer() {
    return this.form.get('coBuyer') as FormControl<string>;
  }

  form = this.fb.group({
    buyer: [null, [EmailWithTLDValidator, Validators.required]],
    coBuyer: [null, [EmailWithTLDValidator]]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SaleUpdateBuyersDialogData,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CompanyDialogComponent>,
    private salesService: SalesManagementService,
    private alertService: AlertService,
    private userHelper: UserHelper,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.dialogTitle = 'saleBuyersDialog.title';
  }

  ngOnInit(): void {
    this.autoCompletionType = this.userHelper.isAdmin() ? 'users' : 'contacts';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  initForm() {}

  onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.addBuyer();
    }
  }

  addBuyer() {
    this.isLoading = true;
    this.sub = this.salesService
      .addSaleBuyers(this.data.sale.uid, this.form_buyer.value, this.form_coBuyer.value)
      .subscribe({
        next: (uid: string) => {
          this.alertService.success('Acheteurs ajoutés');
          this.dialogRef.close(true);
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
